import { Button } from '@amzn/awsui-components-react';
import { EuiEmptyPrompt } from '@elastic/eui';
import React from 'react';

const LoadGraphs = (props: any) => (
  <EuiEmptyPrompt
    title={<h4>Load cloud watch graphs ?</h4>}
    actions={[
      <Button variant="normal" onClick={props.onClick}>
        Display graphs
      </Button>,
    ]}
  />
);

export { LoadGraphs };
